(function(){
  'use strict';

  /* ---------- toast ---------- */
  var toast=document.getElementById('toast'), tt=document.getElementById('tt'), tid;
  function say(m){
    if(!toast||!tt) return;
    tt.textContent=m; toast.classList.add('show'); clearTimeout(tid);
    tid=setTimeout(function(){toast.classList.remove('show');},3800);
  }
  window.HaColoToast = say;


  /* ---------- sticky header ----------
     CSS does the sticking (the header's section is sticky, the red promo bar scrolls away); here only the header
     height is measured for blocks that stop just below it (--hdr-h). */
  var stickyWrap=document.querySelector('.site-header-sticky');
  var fixedHead=stickyWrap && stickyWrap.querySelector('.head');
  var promoBar=stickyWrap && stickyWrap.querySelector('.topbar');
  var promoH=0;
  function syncHeaderHeight(){
    if(!stickyWrap || !fixedHead) return;
    promoH = promoBar ? promoBar.offsetHeight : 0;
    stickyWrap.style.setProperty('--promo-h', promoH + 'px');
    // height of the white header - sticky blocks (cart summary) stop just below it
    document.documentElement.style.setProperty('--hdr-h', fixedHead.offsetHeight + 'px');
  }
  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);
  // the rotating promo messages can change the bar height
  if(window.ResizeObserver && stickyWrap){ var ro=new ResizeObserver(syncHeaderHeight); if(promoBar) ro.observe(promoBar); if(fixedHead) ro.observe(fixedHead); }

  /* ---------- mobile menu ---------- */
  var burg=document.getElementById('burg'), mnav=document.getElementById('mnav');
  if(burg && mnav){
    burg.addEventListener('click', function(){
      var o=mnav.classList.toggle('open');
      burg.setAttribute('aria-expanded', o?'true':'false');
      // the page behind stays still while the menu is open; the menu scrolls inside itself
      document.documentElement.classList.toggle('mnav-lock', o);
      if(headEl2 && !o) headEl2.classList.remove('is-hidden');
      if(o){ mnav.scrollTop=0; }
      syncHeaderHeight();
      mnFit();
    });
    // the header is fixed, so the menu ends at the bottom of the screen - above Shopify's admin preview bar, if shown
    // the menu lives on <body>, not inside the header: the header slides away (transform) while the menu is scrolled,
    // and a transformed parent would drag a fixed child along with it
    document.body.appendChild(mnav);
    var headEl2=document.querySelector('.site-header-sticky .head');
    function mnFit(){
      if(!mnav.classList.contains('open')) return;
      // the open menu is its own fixed layer from just under the header row (or the very top when the header is
      // hidden) down to the bottom of the screen
      var row=document.querySelector('.head .hrow'), top=row ? row.getBoundingClientRect().bottom : 0;
      mnav.style.top=Math.max(0, top)+'px';
      mnav.style.maxHeight='';
      var bar=document.getElementById('preview-bar-iframe');
      mnav.style.bottom=(bar ? bar.getBoundingClientRect().height : 0)+'px';
    }
    window.addEventListener('resize', mnFit);
    // keep scrolling down after the end of the menu = the menu closes by itself (wheel / trackpad / finger)
    function mnClose(){
      if(!mnav.classList.contains('open')) return;
      mnav.classList.add('is-closing');
      setTimeout(function(){ mnav.classList.remove('is-closing'); if(mnav.classList.contains('open')) burg.click(); }, 220);
    }
    function mnAtEnd(){ return mnav.scrollTop + mnav.clientHeight >= mnav.scrollHeight - 2; }
    var mnPull=0;
    mnav.addEventListener('wheel', function(e){
      if(e.deltaY > 0 && mnAtEnd()){ mnPull+=e.deltaY; if(mnPull > 120){ mnPull=0; mnClose(); } }
      else mnPull=0;
    }, {passive:true});
    var mnTouchY=null, mnTouchEnd=false;
    mnav.addEventListener('touchstart', function(e){ mnTouchY=e.touches[0].clientY; mnTouchEnd=mnAtEnd(); }, {passive:true});
    mnav.addEventListener('touchend', function(e){
      if(mnTouchY==null) return;
      var dy=mnTouchY - e.changedTouches[0].clientY; mnTouchY=null;
      if(mnTouchEnd && mnAtEnd() && dy > 60) mnClose();
    }, {passive:true});
    window.addEventListener('scroll', mnFit, {passive:true});
    // department tabs (remembered), group rows open a panel of subcategory circles, "‹" goes back
    var MTAB='hacolo_mtab';
    function mnTab(n){
      mnav.querySelectorAll('[data-mn-tab]').forEach(function(t){ var on=t.dataset.mnTab===String(n); t.classList.toggle('is-on',on); t.setAttribute('aria-selected',on?'true':'false'); });
      mnav.querySelectorAll('[data-mn-pane]').forEach(function(p){ p.hidden=p.dataset.mnPane!==String(n); });
      mnav.querySelectorAll('[data-mn-sub]').forEach(function(p){ p.hidden=true; });
      mnav.classList.remove('is-sub');
      try{ localStorage.setItem(MTAB, n); }catch(e){}
    }
    try{ var saved=localStorage.getItem(MTAB); if(saved && mnav.querySelector('[data-mn-tab="'+saved+'"]')) mnTab(saved); }catch(e){}
    mnav.addEventListener('click', function(e){
      var t=e.target.closest('[data-mn-tab]'); if(t){ mnTab(t.dataset.mnTab); return; }
      var r=e.target.closest('[data-mn-open]');
      if(r){
        mnav.querySelectorAll('[data-mn-pane]').forEach(function(p){ p.hidden=true; });
        var sub=mnav.querySelector('[data-mn-sub="'+r.dataset.mnOpen+'"]'); if(sub) sub.hidden=false;
        mnav.classList.add('is-sub'); mnav.scrollTop=0; return;
      }
      if(e.target.closest('[data-mn-back]')){
        var cur=mnav.querySelector('.mn-tab.is-on'); mnTab(cur ? cur.dataset.mnTab : 1);
      }
    });
  }

  /* ---------- phones: the header hides while scrolling down and comes back on a small scroll up ----------
     Not while the menu is open or the search box is in use. */
  (function(){
    var head=document.querySelector('.site-header-sticky .head'); if(!head) return;
    var phone=window.matchMedia('(max-width:899px)'), lastY=window.scrollY;
    function upd(){
      var y=window.scrollY, d=y-lastY;
      var busy=document.documentElement.classList.contains('mnav-lock') || head.contains(document.activeElement);
      if(!phone.matches || busy || y < head.offsetHeight + 60){ head.classList.remove('is-hidden'); lastY=y; return; }
      if(d > 6) head.classList.add('is-hidden');
      else if(d < -6) head.classList.remove('is-hidden');
      if(Math.abs(d) > 6) lastY=y;
    }
    window.addEventListener('scroll', upd, {passive:true});
  })();

  /* ---------- header shadow on scroll ---------- */
  var headEl=document.querySelector('.head');
  if(headEl){
    var onScroll=function(){
      headEl.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- tabs (new/sale rails) ---------- */
  document.querySelectorAll('.tabs').forEach(function(tabGroup){
    var id=tabGroup.dataset.tabsFor;
    tabGroup.querySelectorAll('.tab').forEach(function(t){
      t.addEventListener('click', function(){
        tabGroup.querySelectorAll('.tab').forEach(function(x){ x.setAttribute('aria-selected','false'); });
        t.setAttribute('aria-selected','true');
        var g=t.dataset.g;
        document.querySelectorAll('.rail[data-group][data-rail-for="'+id+'"]').forEach(function(r){
          r.hidden = r.dataset.group!==g;
          if(!r.hidden){ r.scrollLeft=0; var c=r.closest('.carousel'); if(c && c._restart) c._restart(); }
        });
        document.querySelectorAll('.see-all [data-group][data-link-for="'+id+'"]').forEach(function(a){ a.hidden = a.dataset.group!==g; });
      });
    });
  });

  /* ---------- trust tiles: fade in one after another when scrolled into view ---------- */
  document.querySelectorAll('.trust--cards').forEach(function(t){
    if(!('IntersectionObserver' in window)) return;
    t.classList.add('js-reveal');
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ t.classList.add('is-in'); io.disconnect(); } }); }, {threshold:.25});
    io.observe(t);
    // safety net: never leave the tiles invisible (e.g. a browser that does not report the intersection)
    setTimeout(function(){ t.classList.add('is-in'); }, 4000);
  });

  /* ---------- hero slideshow ---------- */
  // click on a banner: buttons work as they are; the photo half opens the product shown, the rest the category.
  // Decided by where the click landed (not by stacked link layers - Safari hit-tested those wrongly).
  document.addEventListener('click', function(e){
    var slide=e.target.closest('.hero .slide.is-on'); if(!slide) return;
    if(e.target.closest('.hbtns a, .hpicks a, .snav, .sdot')) return;
    // phones: the photo's product link lies over the text block, so a tap on a button lands on the photo -
    // the button under the finger wins
    var btn=[].slice.call(slide.querySelectorAll('.hbtns a')).find(function(a){
      var b=a.getBoundingClientRect(); return e.clientX>=b.left && e.clientX<=b.right && e.clientY>=b.top && e.clientY<=b.bottom; });
    if(btn){ e.preventDefault(); if(e.metaKey || e.ctrlKey) window.open(btn.href, '_blank'); else window.location.href=btn.href; return; }
    var media=slide.querySelector('.hmedia'), url=slide.dataset.href;
    if(media && slide.dataset.productHref){
      var r=media.getBoundingClientRect();
      if(e.clientX>=r.left && e.clientX<=r.right && e.clientY>=r.top && e.clientY<=r.bottom) url=slide.dataset.productHref;
    }
    if(!url) return;
    e.preventDefault();
    if(e.metaKey || e.ctrlKey) window.open(url, '_blank'); else window.location.href=url;
  });
  document.querySelectorAll('[data-slider]').forEach(function(box){
    var slides=[].slice.call(box.querySelectorAll('.slide'));
    var dots=[].slice.call(box.querySelectorAll('.sdot'));
    if(!slides.length) return;
    var i=0, timer=null;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n){
      i=(n+slides.length)%slides.length;
      slides.forEach(function(s,k){ s.classList.toggle('is-on', k===i); });
      dots.forEach(function(d,k){ d.setAttribute('aria-selected', k===i?'true':'false'); });
    }
    function play(){
      if(still || slides.length<2) return;
      stop(); timer=setInterval(function(){ show(i+1); }, 4000);
      // restart the progress bar in the active dot so it stays in step with the timer
      var d=dots[i]; if(d){ d.setAttribute('aria-selected','false'); void d.offsetWidth; d.setAttribute('aria-selected','true'); }
    }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ show(k); play(); }); });
    var prev=box.querySelector('.snav.prev'), next=box.querySelector('.snav.next');
    if(prev) prev.addEventListener('click', function(){ show(i-1); play(); });
    if(next) next.addEventListener('click', function(){ show(i+1); play(); });
    // hidden slides have lazy photos that would only start loading when shown (empty slide for a moment after a swipe):
    // once the page has loaded, fetch them in the background
    function warm(){ box.querySelectorAll('img[loading="lazy"]').forEach(function(im){ im.loading='eager'; }); }
    if(document.readyState==='complete') warm(); else window.addEventListener('load', warm);
    // phones: swipe left / right changes the slide (a mostly vertical move still scrolls the page)
    var tx=null, ty=0;
    box.addEventListener('touchstart', function(e){ if(e.touches.length===1){ tx=e.touches[0].clientX; ty=e.touches[0].clientY; } }, {passive:true});
    box.addEventListener('touchend', function(e){
      if(tx===null || slides.length<2) return;
      var dx=e.changedTouches[0].clientX-tx, dy=e.changedTouches[0].clientY-ty; tx=null;
      if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.2){ show(dx<0 ? i+1 : i-1); play(); }
    }, {passive:true});
    // mouse over one of the products on a slide: the slider waits (the product's photos keep changing), then starts the full time again
    box.querySelectorAll('.hpick').forEach(function(p){
      p.addEventListener('mouseenter', function(){ stop(); box.classList.add('is-paused'); });
      p.addEventListener('mouseleave', function(){ box.classList.remove('is-paused'); play(); });
    });
    play();
  });

  /* ---------- carousels: arrows (wrap around at the ends) + autoplay ----------
     Autoplay moves by one card; an arrow click moves a whole screen of cards (like Allegro).
     [data-autoplay="5"] = every 5 s; pauses while the mouse is over a product, a finger is on it (phones)
     or it is off screen. Switching tabs restarts from the first card. */
  var stillMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // eased scroll with Allegro's curve (measured there: cubic-bezier(.4,.05,0,1) - quick start, long soft stop),
  // a bit slower than theirs. The row jumps to the target at once and the cards slide in with a CSS transform:
  // moving scrollLeft frame by frame went in whole pixels, so the soft stop at the end shook a little.
  var GLIDE_CURVE='cubic-bezier(.4,.05,0,1)', GLIDE_MS=900;
  function glide(r, to, ms){
    ms=ms||GLIDE_MS;
    var kids=[].slice.call(r.children);
    // a glide still running: start from where the cards are on screen now
    // the slide uses the separate "translate" property: a card's hover lift ("transform") during a glide
    // restarted the card's own animation and it jumped out of the row
    var m=kids.length ? getComputedStyle(kids[0]).translate : 'none';
    var tx=(m && m!=='none') ? parseFloat(m)||0 : 0;
    var from=r.scrollLeft - tx;
    clearTimeout(r._gt);
    kids.forEach(function(k){ k.style.transition='none'; k.style.translate=''; });
    r.style.scrollSnapType='none'; r.style.scrollBehavior='auto';
    r.scrollLeft=to;
    var off=r.scrollLeft-from;   // the browser may clamp "to" at the end of the row
    function done(){ kids.forEach(function(k){ k.style.transition=''; k.style.translate=''; }); r.style.scrollSnapType=''; r.style.scrollBehavior=''; r._target=null; r._stop=null; }
    // a finger on the row mid-glide: freeze the cards where they are on screen and hand the row back to the
    // browser at once (the timer ending the glide during the drag made the row jump and fight the finger)
    r._stop=function(){
      clearTimeout(r._gt);
      var m=getComputedStyle(kids[0]).translate, t=(m && m!=='none') ? parseFloat(m)||0 : 0;
      kids.forEach(function(k){ k.style.transition='none'; k.style.translate=''; });
      r.scrollLeft=r.scrollLeft - t;
      void r.offsetWidth;
      done();
    };
    if(stillMotion || Math.abs(off)<2){ done(); return; }
    kids.forEach(function(k){ k.style.translate=off+'px 0'; });
    void r.offsetWidth;   // apply the start position before the transition begins
    kids.forEach(function(k){ k.style.transition='translate '+ms+'ms '+GLIDE_CURVE+', transform .2s, box-shadow .2s'; k.style.translate=''; });
    r._gt=setTimeout(done, ms+40);
  }
  function initCarousel(box){
    if(box._ready) return; box._ready=true;
    function rail(){ return box.querySelector('.rail:not([hidden])'); }
    function step(r){
      var card=r.firstElementChild, gap=parseFloat(getComputedStyle(r).columnGap)||0;
      return card ? card.getBoundingClientRect().width + gap : r.clientWidth*0.8;
    }
    // page=true: all fully visible cards at once (arrow click); otherwise one card (autoplay)
    function go(dir, page){
      var r=rail(); if(!r) return;
      var max=r.scrollWidth - r.clientWidth;
      if(max<=2) return;
      // targets are the real card edges (where snapping would put the row), not multiples of a rounded width
      var cards=[].slice.call(r.children).filter(function(c){ return c.offsetWidth; });
      if(!cards.length) return;
      var x0=cards[0].offsetLeft, edges=cards.map(function(c){ return Math.min(max, Math.round(c.offsetLeft-x0)); });
      var st=step(r), gap=parseFloat(getComputedStyle(r).columnGap)||0;
      var n=page ? Math.max(1, Math.floor((r.clientWidth+gap+2)/st)) : 1;   // the last visible card has no gap after it
      var cur=r._target!=null ? r._target : r.scrollLeft, i=0;
      edges.forEach(function(e, k){ if(Math.abs(e-cur) < Math.abs(edges[i]-cur)) i=k; });
      var to;
      if(dir>0) to = cur>=max-4 ? 0 : edges[Math.min(edges.length-1, i+n)];
      else to = cur<=4 ? max : edges[Math.max(0, i-n)];
      r._target=to;
      glide(r, to, page ? GLIDE_MS : 650);   // autoplay: one card, quicker, so the row rests on whole cards most of the time
    }
    // photos of the cards further along load before the row moves (loading them mid-glide made it stutter)
    function warm(){ box.querySelectorAll('.rail img[loading="lazy"]').forEach(function(im){ im.loading='eager'; }); }
    if('IntersectionObserver' in window){
      var wio=new IntersectionObserver(function(en){ if(en[0].isIntersecting){ warm(); wio.disconnect(); } }, {rootMargin:'300px 0px'});
      wio.observe(box);
    } else warm();
    box.querySelectorAll('.arrow').forEach(function(a){
      a.addEventListener('click', function(){ go(+a.dataset.dir, true); restart(); });
    });

    var secs=+(box.dataset.autoplay||0), timer=null, hover=false, visible=true;
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function restart(){
      stop();
      if(!secs || stillMotion || hover || !visible || document.hidden) return;
      timer=setInterval(function(){ go(1); }, Math.max(3, secs)*1000);
    }
    if(secs){
      // stop while the mouse is over a product card, so a size/colour can be picked and added to the cart
      box.querySelectorAll('.rail > *').forEach(function(card){
        card.addEventListener('mouseenter', function(){ hover=true; stop(); });
        card.addEventListener('mouseleave', function(){ hover=false; restart(); });
      });
      // phones: once the row is moved by finger the customer drives it - no more autoplay on this carousel
      box.addEventListener('touchstart', function(){ secs=0; stop(); }, {passive:true});
      document.addEventListener('visibilitychange', restart);
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en){ visible=en[0].isIntersecting; restart(); }, {threshold:0.3}).observe(box);
      }
      restart();
    }
    box.addEventListener('touchstart', function(){ var r=rail(); if(r && r._stop) r._stop(); }, {passive:true});
    box._restart=restart;
  }
  document.querySelectorAll('.carousel').forEach(initCarousel);
  /* ---------- wishlist (localStorage, no backend) ---------- */
  var WISH_KEY='hacolo_wishlist';
  function getWishlist(){
    try{ return JSON.parse(localStorage.getItem(WISH_KEY)||'[]'); }catch(e){ return []; }
  }
  function setWishlist(arr){
    try{ localStorage.setItem(WISH_KEY, JSON.stringify(arr)); }catch(e){}
  }
  function updateWishCount(){
    var n=getWishlist().length;
    document.querySelectorAll('[data-wish-count]').forEach(function(el){
      el.textContent=n; el.hidden = n===0;
    });
  }
  function syncWishButtons(){
    var list=getWishlist();
    document.querySelectorAll('.hrt[data-product-handle]').forEach(function(b){
      var on=list.indexOf(b.dataset.productHandle)>-1;
      b.setAttribute('aria-pressed', on?'true':'false');
    });
  }
  document.addEventListener('click', function(e){
    var b=e.target.closest('.hrt[data-product-handle]');
    if(!b) return;
    e.preventDefault();
    var handle=b.dataset.productHandle;
    var list=getWishlist();
    var idx=list.indexOf(handle);
    var on;
    if(idx>-1){ list.splice(idx,1); on=false; } else { list.push(handle); on=true; }
    setWishlist(list);
    document.querySelectorAll('.hrt[data-product-handle="'+handle+'"]').forEach(function(x){
      x.setAttribute('aria-pressed', on?'true':'false');
    });
    updateWishCount();
    say(on?'Zapisano w ulubionych':'Usunięto z ulubionych');
    if(typeof window.HaColoRenderWishlist === 'function') window.HaColoRenderWishlist();
  });
  updateWishCount();
  syncWishButtons();
  window.HaColoWishlist = { get: getWishlist, WISH_KEY: WISH_KEY };

  /* ---------- size selection ---------- */
  /* card "Do koszyka": ready (size picked) / need (no size yet - stays clickable and asks for one) / off (sold out) */
  function setAddState(btn, state){
    btn.disabled = state==='off';
    if(state==='need') btn.setAttribute('data-needs-size',''); else btn.removeAttribute('data-needs-size');
    var card=btn.closest('.card'), hint=card && card.querySelector('.card-hint');
    if(hint && state!=='need') hint.remove();
  }
  function askForSize(card){
    var szs=card.querySelector('.szs');
    var hint=card.querySelector('.card-hint');
    if(!hint){
      hint=document.createElement('p'); hint.className='card-hint'; hint.setAttribute('role','alert');
      hint.textContent='Najpierw wybierz rozmiar';
      var btn=card.querySelector('.add'); btn.parentNode.insertBefore(hint, btn);
    }
    if(szs){ szs.classList.remove('shake'); void szs.offsetWidth; szs.classList.add('shake'); }
    clearTimeout(card._hintT);
    card._hintT=setTimeout(function(){ if(hint.parentNode) hint.remove(); }, 3500);
  }

  document.addEventListener('click', function(e){
    var b=e.target.closest('.szs button:not(.out)');
    if(!b) return;
    b.parentElement.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
    b.setAttribute('aria-pressed','true');
    var card=b.closest('.card');
    if(card){
      var addBtn=card.querySelector('.add');
      if(addBtn){
        addBtn.dataset.variantId=b.dataset.variantId||'';
        setAddState(addBtn, addBtn.dataset.variantId ? 'ready' : 'need');
      }
    }
  });

  /* ---------- mega menu: show the circles of the hovered group ---------- */
  document.querySelectorAll('[data-subnav-tabs]').forEach(function(box){
    var tabs=box.querySelectorAll('.subnav-tab[data-panel]');
    function show(tab){
      tabs.forEach(function(t){ t.classList.toggle('is-active', t===tab); });
      box.querySelectorAll('.subnav-panel').forEach(function(p){ p.hidden = p.dataset.panel!==tab.dataset.panel; });
    }
    tabs.forEach(function(tab){
      tab.addEventListener('mouseenter', function(){ show(tab); });
      tab.addEventListener('focus', function(){ show(tab); });
    });
  });

  /* ---------- cards with a single size (e.g. "Uniwersalny"): pick it, so "Do koszyka" works at once ---------- */
  function autoPickSingleSize(card){
    var btns=card.querySelectorAll('.szs button[data-size]:not(.out)');
    var all=card.querySelectorAll('.szs button[data-size]');
    var add=card.querySelector('.add');
    if(all.length===1 && btns.length===1 && add){
      btns[0].setAttribute('aria-pressed','true');
      add.dataset.variantId=btns[0].dataset.variantId||'';
      setAddState(add, add.dataset.variantId ? 'ready' : 'need');
    }
  }
  document.querySelectorAll('.card').forEach(autoPickSingleSize);

  /* ---------- card colour swatches: swap photo + sizes for the chosen colour ---------- */
  document.addEventListener('click', function(e){
    var dot=e.target.closest('.card .dots button[data-color]');
    if(!dot) return;
    var card=dot.closest('.card');
    var dataEl=card.querySelector('[data-card-variants]');
    var variants=[];
    try{ variants=JSON.parse(dataEl ? dataEl.textContent : '[]'); }catch(err){}
    var color=dot.dataset.color;
    dot.parentElement.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
    dot.setAttribute('aria-pressed','true');

    var img=card.querySelector('[data-card-img]');
    if(img && dot.dataset.img){ img.removeAttribute('srcset'); img.src=dot.dataset.img; }

    // colour = separate product: point links, wishlist heart and price at that product
    if(dot.dataset.url){
      card.querySelectorAll('[data-card-link]').forEach(function(a){ a.href=dot.dataset.url; });
      var heart=card.querySelector('.hrt[data-product-handle]');
      if(heart && dot.dataset.handle){
        heart.dataset.productHandle=dot.dataset.handle;
        var saved=(window.HaColoWishlist ? window.HaColoWishlist.get() : []).indexOf(dot.dataset.handle)>-1;
        heart.setAttribute('aria-pressed', saved?'true':'false');
      }
      var pz=card.querySelector('[data-card-price]');
      if(pz && dot.dataset.price){
        pz.innerHTML = dot.dataset.compare
          ? '<b class="sale">'+dot.dataset.price+'</b><s>'+dot.dataset.compare+'</s><small class="omni">Najniższa cena z 30 dni przed obniżką: '+dot.dataset.compare+'</small>'
          : '<b>'+dot.dataset.price+'</b>';
      }
    }

    var addBtn=card.querySelector('.add');
    var sizeBtns=card.querySelectorAll('.szs button[data-size]');
    if(sizeBtns.length){
      sizeBtns.forEach(function(b){
        var v=variants.find(function(x){ return x.c===color && x.s===b.dataset.size; });
        b.setAttribute('aria-pressed','false');
        b.dataset.variantId=v ? v.id : '';
        var ok=!!(v && v.a);
        b.disabled=!ok;
        b.classList.toggle('out', !ok);
      });
      if(addBtn){ addBtn.dataset.variantId=''; setAddState(addBtn, 'need'); }
      autoPickSingleSize(card);
    } else if(addBtn){
      var only=variants.find(function(x){ return x.c===color; });
      addBtn.dataset.variantId=only ? only.id : '';
      setAddState(addBtn, only && only.a ? 'ready' : 'off');
    }
  });

  /* ---------- photo gallery on every product tile ([data-gallery] = space-separated photo URLs) ----------
     Arrows + bars are added here, so any tile only needs data-gallery on its photo box.
     Mouse: arrows on hover. Touch: swipe in product grids (in carousels a swipe scrolls the carousel). */
  var CG_ARROWS='<button type="button" class="cg cg--prev" aria-label="Poprzednie zdjęcie" data-cg="-1"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m15 6-6 6 6 6"/></svg></button>'+
    '<button type="button" class="cg cg--next" aria-label="Następne zdjęcie" data-cg="1"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m9 6 6 6-6 6"/></svg></button>'+
    '<span class="cg-bars" aria-hidden="true"></span>';
  function cgList(g){ return (g.dataset.gallery||'').split(' ').filter(Boolean); }
  function cgImg(g){ return g.querySelector('img[data-card-img]') || g.querySelector('img'); }
  function cgInit(g){
    var list=cgList(g);
    if(!g.querySelector('.cg-bars')) g.insertAdjacentHTML('beforeend', CG_ARROWS);
    g.classList.toggle('has-gal', list.length>1);
    g._cg=0;
    g.querySelector('.cg-bars').innerHTML=list.length>1 ? list.map(function(_,k){ return '<i'+(k===0?' class="on"':'')+'></i>'; }).join('') : '';
  }
  function cgGo(g, dir){
    var list=cgList(g); if(list.length<2) return;
    var i=((g._cg||0)+dir+list.length)%list.length; g._cg=i;
    var img=cgImg(g);
    if(img){ img.removeAttribute('srcset'); img.src=list[i]; }
    g.querySelectorAll('.cg-bars i').forEach(function(b,k){ b.classList.toggle('on', k===i); });
    var pre=new Image(); pre.src=list[(i+dir+list.length)%list.length];   // next one ready before the next click
  }
  window.HaColoCardGallery=function(root){ (root||document).querySelectorAll('[data-gallery]').forEach(function(g){ if(!g._cgReady && !g.matches('button')){ g._cgReady=true; cgInit(g); } }); };
  window.HaColoCardGallery();
  // mouse over a tile: photos change by themselves every 2 s; leaving the tile goes back to the first photo
  var CG_TILE='.card,.mini,.hpick,.rec', cgHover=null, cgTimer=null, cgFirst=null;
  function cgStop(){
    clearTimeout(cgFirst); clearInterval(cgTimer); cgFirst=cgTimer=null;
    if(cgHover){ var g=cgHover; cgHover=null; if(g._cg){ g._cg=1; cgGo(g, -1); } }
  }
  document.addEventListener('mouseover', function(e){
    if(!e.target.closest) return;
    var tile=e.target.closest(CG_TILE), g=tile && tile.querySelector('.has-gal');
    if(g===cgHover) return;
    cgStop();
    if(!g) return;
    cgHover=g;
    if(!g._pre){ g._pre=true; var l=cgList(g); if(l[1]){ var p=new Image(); p.src=l[1]; } }
    cgFirst=setTimeout(function(){ cgGo(g, 1); cgTimer=setInterval(function(){ cgGo(g, 1); }, 2000); }, 1000);
  });
  document.documentElement.addEventListener('mouseleave', cgStop);
  // an arrow click restarts the 2 s count, so the photo does not jump right after the click
  function cgRestart(g){ if(g!==cgHover) return; clearTimeout(cgFirst); clearInterval(cgTimer); cgTimer=setInterval(function(){ cgGo(g, 1); }, 2000); }
  document.addEventListener('click', function(e){
    var b=e.target.closest('.has-gal [data-cg]');
    if(b){ e.preventDefault(); e.stopPropagation(); var bg=b.closest('.has-gal'); cgGo(bg, +b.dataset.cg); cgRestart(bg); return; }
    var dot=e.target.closest('.card .dots button[data-gallery]');
    if(dot){ var g=dot.closest('.card').querySelector('.cm[data-gallery]'); if(g){ g.dataset.gallery=dot.dataset.gallery; cgInit(g); } }
  }, true);
  var cgT=null;
  document.addEventListener('touchstart', function(e){
    var g=e.target.closest('.grid-products .has-gal'); if(!g || e.touches.length>1){ cgT=null; return; }
    cgT={g:g, x:e.touches[0].clientX, y:e.touches[0].clientY};
  }, {passive:true});
  document.addEventListener('touchend', function(e){
    if(!cgT) return;
    var t=e.changedTouches[0], dx=t.clientX-cgT.x, dy=t.clientY-cgT.y, g=cgT.g; cgT=null;
    if(Math.abs(dx)>35 && Math.abs(dx)>Math.abs(dy)*1.3){
      cgGo(g, dx<0 ? 1 : -1);
      g._swiped=Date.now();   // the tap that ends a swipe must not open the product
    }
  }, {passive:true});
  document.addEventListener('click', function(e){
    var g=e.target.closest('.has-gal'); if(g && g._swiped && Date.now()-g._swiped<400){ e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ---------- grid view toggle (category page): bigger photos (default) / more per row, remembered ---------- */
  function gridSync(){
    var big=document.documentElement.classList.contains('grid-big');
    document.querySelectorAll('[data-grid-view]').forEach(function(b){ b.setAttribute('aria-pressed', (b.dataset.gridView==='big')===big ? 'true' : 'false'); });
  }
  gridSync();
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-grid-view]'); if(!b) return;
    var big=b.dataset.gridView==='big';
    document.documentElement.classList.toggle('grid-big', big);
    try{ if(big) localStorage.removeItem('hacolo_grid'); else localStorage.setItem('hacolo_grid','std'); }catch(err){}
    gridSync();
  });

  /* ---------- category page: next page loads by itself near the end of the list ----------
     The products of the next page are added to the grid and its pager replaces this one; the button
     "Pokaż więcej" also loads it on click (and is the plain link when JS is off). */
  var collGrid=document.querySelector('[data-coll-grid]');
  function pagerInit(){
    var pager=document.querySelector('[data-pager]'), next=pager && pager.querySelector('[data-pager-next]');
    if(!collGrid || !next) return;
    pager.classList.add('is-auto');
    next.textContent='Pokaż więcej';
    var busy=false, io=null;
    function load(){
      if(busy) return; busy=true;
      pager.classList.add('is-loading'); next.textContent='Wczytywanie…';
      fetch(next.href).then(function(r){ return r.text(); }).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var grid=doc.querySelector('[data-coll-grid]'), newPager=doc.querySelector('[data-pager]');
        var box=document.createElement('div');
        if(grid) [].slice.call(grid.children).forEach(function(c){ box.appendChild(c); });
        var added=[].slice.call(box.children);
        added.forEach(function(c){ collGrid.appendChild(c); });
        if(io) io.disconnect();
        if(newPager && newPager.querySelector('[data-pager-next]')){
          newPager.querySelectorAll('a:not([data-pager-next])').forEach(function(a){ a.remove(); });   // "Poprzednia" of a page already shown above
          pager.replaceWith(document.importNode(newPager, true));
        }
        else pager.remove();
        if(window.HaColoReadyCards) window.HaColoReadyCards(collGrid);
        pagerInit();
      }).catch(function(){ busy=false; pager.classList.remove('is-loading'); next.textContent='Pokaż więcej'; });
    }
    next.addEventListener('click', function(e){ e.preventDefault(); load(); });
    if('IntersectionObserver' in window){
      io=new IntersectionObserver(function(en){ if(en[0].isIntersecting) load(); }, {rootMargin:'0px 0px 700px 0px'});
      io.observe(pager);
    }
  }
  pagerInit();

  /* ---------- category circles row: arrows + mouse drag when the circles do not fit (phones) ---------- */
  document.querySelectorAll('.circ-row').forEach(function(row){
    var rail=row.querySelector('.in'); if(!rail) return;
    var arrow='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m15 6-6 6 6 6"/></svg>';
    row.insertAdjacentHTML('beforeend', '<button type="button" class="circ-nav circ-nav--prev" aria-label="Przewiń w lewo">'+arrow+'</button>'+
      '<button type="button" class="circ-nav circ-nav--next" aria-label="Przewiń w prawo">'+arrow.replace('m15 6-6 6 6 6','m9 6 6 6-6 6')+'</button>');
    function sync(){
      var max=rail.scrollWidth-rail.clientWidth;
      row.classList.toggle('can-prev', rail.scrollLeft>4);
      row.classList.toggle('can-next', rail.scrollLeft<max-4);
    }
    row.querySelector('.circ-nav--prev').addEventListener('click', function(){ rail.scrollBy({left:-rail.clientWidth*0.7, behavior:'smooth'}); });
    row.querySelector('.circ-nav--next').addEventListener('click', function(){ rail.scrollBy({left:rail.clientWidth*0.7, behavior:'smooth'}); });
    rail.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    sync();
    // mouse drag (touch scrolls natively); a drag must not open the circle under the mouse
    var d=null;
    rail.addEventListener('mousedown', function(e){ if(rail.scrollWidth>rail.clientWidth){ d={x:e.clientX,l:rail.scrollLeft,moved:false}; e.preventDefault(); } });
    window.addEventListener('mousemove', function(e){ if(!d) return; var dx=e.clientX-d.x; if(Math.abs(dx)>4){ d.moved=true; rail.classList.add('is-drag'); } rail.scrollLeft=d.l-dx; });
    window.addEventListener('mouseup', function(){ if(d){ setTimeout(function(){ rail.classList.remove('is-drag'); },0); d=null; } });
  });

  /* ---------- same-day shipping countdown ("Zamów w ciągu 2 h 15 min – wyślemy dziś") ----------
     Cut-offs from theme settings, counted in Polish time (Europe/Warsaw) whatever the visitor's clock zone.
     Sunday never ships; public holidays are not known here. */
  var SHIP=window.HaColoShip||{};
  var DAY_ACC=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
  function hm(t){ var m=/^(\d{1,2}):(\d{2})$/.exec((t||'').trim()); return m ? (+m[1])*60+(+m[2]) : null; }
  function cutoffFor(day){ return day===0 ? null : hm(day===6 ? SHIP.sat : SHIP.wd); }
  function warsawNow(){
    var parts={};
    new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23'})
      .formatToParts(new Date()).forEach(function(p){ parts[p.type]=p.value; });
    return {day:['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(parts.weekday), min:(+parts.hour)*60+(+parts.minute)};
  }
  function shipText(){
    if(hm(SHIP.wd)==null) return '';
    var now=warsawNow(), c=cutoffFor(now.day), by=SHIP.carrier ? ' z '+SHIP.carrier : '';
    if(c!=null && now.min<c){
      var left=c-now.min, h=Math.floor(left/60), m=left%60;
      return 'Zamów w ciągu <b>'+(h ? h+' h ' : '')+m+' min</b> – wyślemy <b>dziś</b>'+by;
    }
    for(var i=1;i<=7;i++){
      var d=(now.day+i)%7;
      if(cutoffFor(d)!=null) return 'Zamów teraz – wyślemy <b>'+(i===1 ? 'jutro' : 'w '+DAY_ACC[d])+'</b>'+by;
    }
    return '';
  }
  function shipSync(){
    var t=shipText();
    // one <span>: the box is a flex row (icon + text), loose text and <b> would each become a column
    document.querySelectorAll('[data-ship-eta]').forEach(function(el){ el.innerHTML=t ? '<span>'+t+'</span>' : ''; el.hidden=!t; });
    if(t) document.querySelectorAll('[data-ship-eta-text]').forEach(function(el){ el.innerHTML=t; });
  }
  window.HaColoShipSync=shipSync;
  shipSync(); setInterval(shipSync, 30000);

  /* ---------- promo bar: rotating messages (sections/announcement-bar.liquid) ---------- */
  document.querySelectorAll('[data-topbar].topbar--rot').forEach(function(bar){
    var msgs=[].slice.call(bar.querySelectorAll('.tb-msg')), i=0, timer=null;
    var ms=Math.max(2,+bar.dataset.interval||4)*1000;
    function go(n){
      var old=msgs[i]; i=(n+msgs.length)%msgs.length; if(old===msgs[i]) return;
      old.classList.remove('is-on'); old.classList.add('is-out');
      setTimeout(function(){ old.classList.remove('is-out'); },460);
      msgs[i].classList.add('is-on');
    }
    // before the shipping cut-off the "order within X - we ship today" message counts down: it stays 3x longer
    // (and starts first), so customers actually see it; the other messages keep their normal time
    function isShipToday(m){ var t=m.querySelector('[data-ship-eta-text]'); return t && /dziś/.test(t.textContent); }
    function play(){ clearTimeout(timer); timer=setTimeout(function(){ go(i+1); play(); }, isShipToday(msgs[i]) ? ms*3 : ms); }
    var shipIdx=msgs.findIndex(isShipToday);
    if(shipIdx>0){ msgs[i].classList.remove('is-on'); i=shipIdx; msgs[i].classList.add('is-on'); }
    var p=bar.querySelector('[data-tb-prev]'), n=bar.querySelector('[data-tb-next]');
    if(p) p.addEventListener('click',function(){ go(i-1); play(); });
    if(n) n.addEventListener('click',function(){ go(i+1); play(); });
    bar.addEventListener('mouseenter',function(){ clearTimeout(timer); });
    bar.addEventListener('mouseleave',play);
    var x0=null;
    bar.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
    bar.addEventListener('touchend',function(e){
      if(x0==null) return; var dx=e.changedTouches[0].clientX-x0; x0=null;
      if(Math.abs(dx)>30){ go(dx<0 ? i+1 : i-1); play(); }
    });
    // theme editor: show the block being edited
    bar.addEventListener('shopify:block:select',function(e){ var k=msgs.indexOf(e.target); if(k>=0){ clearTimeout(timer); go(k); } });
    bar.addEventListener('shopify:block:deselect',play);
    play();
  });

  /* ---------- back to top button (shows after one screen of scrolling) ---------- */
  var toTop=document.querySelector('[data-to-top]');
  if(toTop){
    var ttSync=function(){
      toTop.classList.toggle('is-on', window.scrollY > window.innerHeight*0.8);
      // preview bar injected after load (no :has support) - lift the button above it
      if(!toTop._pb && document.getElementById('preview-bar-iframe')){ toTop._pb=true; toTop.style.bottom='96px'; }
    };
    window.addEventListener('scroll', ttSync, {passive:true}); ttSync();
    toTop.addEventListener('click', function(){
      window.scrollTo({top:0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
  }

  // iOS Safari applies :active (the touch "hover" of buttons) only when the page listens to touches
  document.addEventListener('touchstart', function(){}, {passive:true});

  /* ---------- filter bar: one dropdown open at a time, close on outside click / Esc ---------- */
  var fbar=document.querySelector('[data-fbar]');
  if(fbar){
    var cur=fbar.querySelector('.fdd--sort input:checked');
    var lbl=fbar.querySelector('[data-sort-label]');
    if(cur && lbl) lbl.textContent=cur.dataset.current;
    fbar.querySelectorAll('.fdd').forEach(function(d){
      d.addEventListener('toggle', function(){
        if(d.open) fbar.querySelectorAll('.fdd[open]').forEach(function(o){ if(o!==d) o.open=false; });
      });
    });
    document.addEventListener('click', function(e){
      var inside=e.target.closest('.fdd');
      // the phone backdrop is the details' ::before, so a tap on it lands on the details itself
      if(inside && e.target!==inside) return;
      fbar.querySelectorAll('.fdd[open]').forEach(function(o){ o.open=false; });
    });
    document.addEventListener('keydown', function(e){
      if(e.key==='Escape') fbar.querySelectorAll('.fdd[open]').forEach(function(o){ o.open=false; });
    });
  }

  /* ---------- footer columns fold on phones ---------- */
  document.querySelectorAll('.fc-t').forEach(function(b){
    b.addEventListener('click', function(){
      var c=b.closest('.fc'); var o=c.classList.toggle('open');
      b.setAttribute('aria-expanded', o?'true':'false');
    });
  });

  /* ---------- product page rows: "Podobne produkty" + "Ostatnio przeglądane" (loaded after the page) ---------- */
  window.HaColoReadyCards=function(box){ readyCards(box); };
  function readyCards(box){
    box.querySelectorAll('.card').forEach(autoPickSingleSize);
    box.querySelectorAll('.carousel').forEach(initCarousel);
    if(window.HaColoCardGallery) window.HaColoCardGallery(box);
    syncWishButtons();
  }
  /* ---------- Christmas string of lights: a wire sagging between hooks, bulbs hanging along it ---------- */
  (function(){
    var boxes=document.querySelectorAll('[data-xmas-lights]'); if(!boxes.length) return;
    var NS='http://www.w3.org/2000/svg', COLORS=['#ff4d4d','#ffd25e','#5ef09a','#6cb8ff','#ff8ad1','#ffb347'];
    function el(n, a){ var e=document.createElementNS(NS,n); for(var k in a) e.setAttribute(k,a[k]); return e; }
    function draw(box){
      var W=box.clientWidth; if(!W) return;
      var span=W<700 ? 90 : 120, n=Math.max(2, Math.round(W/span)), seg=W/n, sag=W<700 ? 14 : 20, top=8;
      var svg=el('svg',{viewBox:'0 0 '+W+' 64',preserveAspectRatio:'none'}), d='', d2='';
      var defs=el('defs',{}); svg.appendChild(defs);
      for(var c=0;c<COLORS.length;c++){
        var g=el('radialGradient',{id:'xh'+c}); g.appendChild(el('stop',{offset:'0%','stop-color':COLORS[c],'stop-opacity':'.9'})); g.appendChild(el('stop',{offset:'100%','stop-color':COLORS[c],'stop-opacity':'0'})); defs.appendChild(g);
        var b=el('linearGradient',{id:'xb'+c,x1:'0',y1:'0',x2:'0',y2:'1'}); b.appendChild(el('stop',{offset:'0%','stop-color':'#fff','stop-opacity':'.85'})); b.appendChild(el('stop',{offset:'35%','stop-color':COLORS[c]})); b.appendChild(el('stop',{offset:'100%','stop-color':COLORS[c]})); defs.appendChild(b);
      }
      // quadratic sag per segment: y(t) = top + 4*sag*t*(1-t)
      for(var i=0;i<n;i++){
        var x0=i*seg, x1=x0+seg;
        d+=(i? '':'M'+x0+' '+top)+' Q'+(x0+seg/2)+' '+(top+2*sag)+' '+x1+' '+top;
        d2+=(i? '':'M'+x0+' '+(top+1.5))+' Q'+(x0+seg/2)+' '+(top+2*sag-2)+' '+x1+' '+(top+1.5);
      }
      svg.appendChild(el('path',{d:d,'class':'wire'})); svg.appendChild(el('path',{d:d2,'class':'wire2'}));
      var k=0, per=W<700 ? 3 : 4;
      for(i=0;i<n;i++){
        for(var j=1;j<=per;j++){
          var t=j/(per+1), x=i*seg+seg*t, y=top+4*sag*t*(1-t), slope=4*sag*(1-2*t)/seg, ang=Math.atan(slope)*180/Math.PI;
          var col=k%COLORS.length, delay=((k*0.53)%2.4).toFixed(2)+'s', g=el('g',{transform:'translate('+x.toFixed(1)+' '+y.toFixed(1)+') rotate('+(ang*0.6).toFixed(1)+')'});
          g.appendChild(el('circle',{'class':'halo',cx:0,cy:13,r:15,fill:'url(#xh'+col+')',style:'animation-delay:'+delay}));
          g.appendChild(el('rect',{'class':'cap',x:-3,y:0,width:6,height:5,rx:1}));
          g.appendChild(el('path',{'class':'bulb',d:'M0 4 C5 4 6 11 5 15 C4 20 2 22 0 22 C-2 22 -4 20 -5 15 C-6 11 -5 4 0 4Z',fill:'url(#xb'+col+')',style:'animation-delay:'+delay}));
          svg.appendChild(g); k++;
        }
      }
      box.innerHTML=''; box.appendChild(svg);
    }
    function all(){ boxes.forEach(draw); }
    all(); var rt=null; addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(all, 150); });
  })();

  /* ---------- Christmas pages: falling snow on a fixed canvas (body.xmas-page) ---------- */
  (function(){
    if(!document.body.classList.contains('xmas-page') || stillMotion) return;
    var cv=document.createElement('canvas'); cv.className='xmas-snow'; cv.setAttribute('aria-hidden','true'); document.body.appendChild(cv);
    var ctx=cv.getContext('2d'), dpr=Math.min(2, window.devicePixelRatio||1), W=0, H=0, flakes=[], run=true, t0=0;
    function size(){ W=innerWidth; H=innerHeight; cv.width=W*dpr; cv.height=H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
    function flake(top){ return {x:Math.random()*W, y:top ? -10 : Math.random()*H, r:.8+Math.random()*2.6, s:.35+Math.random()*.9, w:Math.random()*Math.PI*2, a:.45+Math.random()*.5}; }
    size(); var n=W<700 ? 45 : 110; for(var i=0;i<n;i++) flakes.push(flake(false));
    addEventListener('resize', size);
    document.addEventListener('visibilitychange', function(){ run=!document.hidden; if(run) requestAnimationFrame(tick); });
    function tick(t){
      if(!run) return;
      var dt=Math.min(50, t-(t0||t)); t0=t;
      ctx.clearRect(0,0,W,H);
      for(var i=0;i<flakes.length;i++){
        var f=flakes[i];
        f.w+=dt*.0012; f.y+=f.s*dt*.06; f.x+=Math.sin(f.w)*.35*f.s;
        if(f.y>H+10){ flakes[i]=flake(true); continue; }
        ctx.beginPath(); ctx.arc(f.x,f.y,f.r,0,6.283); ctx.fillStyle='rgba(255,255,255,'+f.a+')'; ctx.fill();
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  /* ---------- section headings: the brush underline draws itself when the heading comes into view ---------- */
  (function(){
    var heads=document.querySelectorAll('.shead'); if(!heads.length) return;
    if(!('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('js-anim');
    // drawn when the heading has come a quarter of the way up the screen, so it happens while the visitor watches
    var io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, {rootMargin:'0px 0px -25% 0px', threshold:0});
    heads.forEach(function(h){ io.observe(h); });
    // a page opened scrolled to the bottom (or "back"): headings above the screen are shown drawn at once
    heads.forEach(function(h){ if(h.getBoundingClientRect().bottom < 0) h.classList.add('is-in'); });
  })();

  /* ---------- light / dark switch (snippets/theme-switch.liquid) ---------- */
  var darkMQ=window.matchMedia('(prefers-color-scheme: dark)');
  function themeNow(){ var t=document.documentElement.getAttribute('data-theme'); return (t==='dark'||t==='light') ? t : (darkMQ.matches ? 'dark' : 'light'); }
  function syncThemeSwitch(){
    var dark=themeNow()==='dark';
    document.querySelectorAll('[data-theme-switch]').forEach(function(b){
      b.classList.toggle('is-dark', dark);
      b.querySelector('[data-theme-label]').textContent = dark ? 'Tryb jasny' : 'Tryb ciemny';
    });
  }
  function setTheme(t){
    var d=document.documentElement, device=darkMQ.matches ? 'dark' : 'light';
    try{ if(t===device) localStorage.removeItem('hacolo_theme'); else localStorage.setItem('hacolo_theme', t); }catch(e){}
    if(t===device){ d.removeAttribute('data-theme'); d.style.colorScheme=''; }   // same as the device: follow it again
    else { d.setAttribute('data-theme', t); d.style.colorScheme=t; }
    var metas=document.querySelectorAll('meta[name="theme-color"]');
    metas.forEach(function(m){
      var dk = t===device ? /dark/.test(m.media) : t==='dark';   // following the device again: each meta its own colour
      m.content = dk ? '#131313' : '#ffffff';
    });
    syncThemeSwitch();
  }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-theme-switch]')) setTheme(themeNow()==='dark' ? 'light' : 'dark');
  });
  if(darkMQ.addEventListener) darkMQ.addEventListener('change', syncThemeSwitch);
  syncThemeSwitch();

  // data-recs-fallback: asked when the first answer has no cards ("Dobierz do stylizacji" -> Shopify's related products)
  function loadRecRows(scope){ (scope||document).querySelectorAll('[data-recs-url]').forEach(function(sec){ loadRecRow(sec, sec.dataset.recsUrl, sec.dataset.recsFallback); }); }
  function loadRecRow(sec, url, fallback){
    var again=function(){ if(fallback) loadRecRow(sec, fallback, null); };
    fetch(url).then(function(r){ return r.text(); }).then(function(html){
      var tmp=document.createElement('div'); tmp.innerHTML=html;
      var res=tmp.querySelector('[data-recs-result]'); if(!res) return again();
      var skip=(sec.dataset.skip||'').split(','), limit=+sec.dataset.limit||10, n=0;
      res.querySelectorAll('.card').forEach(function(c){
        var a=c.querySelector('[data-card-link]'); var h=a ? a.getAttribute('href').split('/products/')[1] : '';
        h=(h||'').split('?')[0];
        if(skip.indexOf(h)>-1 || n>=limit){ c.remove(); } else { n++; }
      });
      if(!n) return again();
      sec.querySelector('[data-recs-target]').appendChild(res);
      sec.hidden=false; readyCards(sec);
    }).catch(again);
  }
  loadRecRows();
  var RECENT_KEY='hacolo_recent';
  var recentSec=document.querySelector('[data-recent]');
  if(recentSec){
    var cur=recentSec.dataset.current, list=[];
    try{ list=JSON.parse(localStorage.getItem(RECENT_KEY)||'[]'); }catch(e){}
    var show=list.filter(function(h){ return h!==cur; }).slice(0, +recentSec.dataset.limit||10);
    try{ localStorage.setItem(RECENT_KEY, JSON.stringify([cur].concat(list.filter(function(h){ return h!==cur; })).slice(0,20))); }catch(e){}
    if(show.length){
      var rail=recentSec.querySelector('[data-recent-rail]');
      Promise.all(show.map(function(h){
        return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/')+'products/'+encodeURIComponent(h)+'?view=card').then(function(r){ return r.ok ? r.text() : ''; }).catch(function(){ return ''; });
      })).then(function(parts){
        rail.innerHTML=parts.join('');
        if(rail.querySelector('.card')){ recentSec.hidden=false; readyCards(recentSec); }
      });
    }
  }

  /* ---------- cart count ---------- */
  function updateCartCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent=count; el.hidden = count===0;
    });
  }

  /* ---------- cart drawer ----------
     mode "added": after add-to-cart (the added item + actions + free shipping + recommendations)
     mode "view":  opened from the header icon (all items with quantity controls + total) */
  var drawer=document.getElementById('CartDrawer');
  var drawerOverlay=document.getElementById('CartDrawerOverlay');
  var drawerTitle=document.getElementById('CartDrawerTitle');
  var drawerItems=document.getElementById('CartDrawerItems');
  var drawerFooter=document.getElementById('CartDrawerFooter');
  var drawerTotalRow=document.getElementById('CartDrawerTotalRow');
  var drawerTotal=document.getElementById('CartDrawerTotal');
  var ROOT=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FREE_FROM=drawer ? +(drawer.dataset.freeShipping||0) : 0;

  function money(cents){
    return (cents/100).toFixed(2).replace('.', ',') + ' zł';
  }
  function esc(t){ var d=document.createElement('div'); d.textContent=t==null?'':String(t); return d.innerHTML; }
  function thumb(url, w){
    if(!url) return '';
    return url + (url.indexOf('?')>-1 ? '&' : '?') + 'width=' + (w||200);
  }
  function optionsText(item){
    return (item.options_with_values||[]).filter(function(o){ return o.value!=='Default Title'; })
      .map(function(o){ return /kolor|color/i.test(o.name) ? o.value.charAt(0).toUpperCase()+o.value.slice(1) : o.name+' '+o.value; })
      .join(' • ');
  }
  function lineHtml(item, withQty){
    return '<div class="cart-drawer-item">' +
      '<a class="im" href="'+item.url+'">' + (item.image?'<img src="'+thumb(item.image,200)+'" alt="" loading="lazy">':'') + '</a>' +
      '<div class="tx">' +
        '<b>'+esc(item.product_title)+'</b>' +
        '<span>'+esc(optionsText(item))+'</span>' +
        (withQty ?
          '<div class="qty-step qty-step--sm">' +
            '<button type="button" data-cart-change="'+item.key+'" data-qty="'+(item.quantity-1)+'" aria-label="Zmniejsz">−</button>' +
            '<input type="number" class="qty-input" data-cart-qty="'+item.key+'" value="'+item.quantity+'" min="0" max="999" inputmode="numeric" pattern="[0-9]*" aria-label="Ilość">' +
            '<button type="button" data-cart-change="'+item.key+'" data-qty="'+(item.quantity+1)+'" aria-label="Zwiększ">+</button>' +
          '</div>' : (item.quantity>1 ? '<span>Ilość: '+item.quantity+'</span>' : '')) +
      '</div>' +
      (withQty ?
        '<div class="cd-side"><span class="price">'+money(item.final_line_price)+'</span>' +
          '<button type="button" class="cd-remove" data-cart-change="'+item.key+'" data-qty="0" aria-label="Usuń '+esc(item.product_title)+'" title="Usuń z koszyka">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/><path d="M10 11v6M14 11v6"/></svg>' +
          '</button></div>'
        : '<span class="price">'+money(item.final_line_price)+'</span>') +
    '</div>';
  }
  function renderShipping(cart){
    var box=document.getElementById('CartDrawerShip');
    if(!box) return;
    if(!FREE_FROM || !cart.item_count){ box.hidden=true; return; }
    var left=FREE_FROM-cart.total_price;
    document.getElementById('CartDrawerShipText').innerHTML = left>0
      ? 'Dodaj produkty za <b>'+money(left)+'</b> i zyskaj darmową dostawę'
      : '<b>Masz darmową dostawę!</b>';
    document.getElementById('CartDrawerShipBar').style.width=Math.min(100, Math.round(cart.total_price*100/FREE_FROM))+'%';
    box.hidden=false;
  }

  /* recommendations (Shopify product recommendations API) - used by the drawer and the cart page */
  var HEART_SVG='<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 20s-7.5-4.6-7.5-9.4A4.1 4.1 0 0 1 12 8a4.1 4.1 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20Z"/></svg>';
  var BAG_SVG='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 12v5M9.5 14.5h5"/></svg>';
  // photos for the tile gallery; the JSON has no metafields, so a size chart is recognised by its wide shape
  function recGallery(p){
    return (p.media||[]).filter(function(m){ return m.media_type==='image' && m.src && !(m.aspect_ratio>1.15); }).slice(0,8)
      .map(function(m){ return thumb(m.src.indexOf('//')===0 ? 'https:'+m.src : m.src, 500); }).join(' ');
  }
  function recCard(p){
    var img=p.featured_image ? thumb(p.featured_image.indexOf('//')===0 ? 'https:'+p.featured_image : p.featured_image, 500) : '';
    var sale=false; // Ajax product JSON has no Omnibus data (custom.omnibus), so no struck-through price here
    // price like Sinsay: big złote, small grosze
    function big(c){ var z=Math.floor(c/100), g=('0'+(c%100)).slice(-2); return '<span class="rp-z">'+z+'</span><span class="rp-g">,'+g+' zł</span>'; }
    return '<div class="rec">' +
      '<a class="rec-im" href="'+p.url+'" data-gallery="'+esc(recGallery(p))+'">'+(img?'<img src="'+img+'" alt="" loading="lazy" data-card-img>':'')+'</a>' +
      '<button class="hrt" aria-pressed="false" aria-label="Do ulubionych" data-product-handle="'+esc(p.handle)+'">'+HEART_SVG+'</button>' +
      '<a class="rec-t" href="'+p.url+'">'+esc(p.title)+'</a>' +
      '<div class="rec-row"><span class="rec-p'+(sale?' is-sale':'')+'">'+big(p.price)+(sale?' <s>'+money(p.compare_at_price)+'</s>':'')+'</span>' +
      '<button type="button" class="rec-bag" data-quick-add aria-label="Wybierz rozmiar i dodaj do koszyka">'+BAG_SVG+'</button></div>' +
      quickSheet(p) +
    '</div>';
  }
  // first the products that go with it ("Dobierz do stylizacji", sections/product-complements.liquid),
  // then Shopify's related products for categories without a rule
  // quick add (like Sinsay): the bag opens the sizes of this colour right on the tile, a tap adds it to the cart
  function quickSheet(p){
    var names=(p.options||[]).map(function(o){ return typeof o==='string' ? o : o.name; });
    var si=names.findIndex(function(n){ return /rozmiar|size/i.test(n); });
    var vs=(p.variants||[]).filter(function(v){ return v.title!=='Default Title'; });
    if(!vs.length) vs=p.variants||[];
    var btns=vs.map(function(v){
      var label=si>-1 ? v['option'+(si+1)] : v.title;
      return '<button type="button" class="qs-size" data-variant="'+v.id+'"'+(v.available?'':' disabled')+'>'+esc(label||'Uniwersalny')+'</button>';
    }).join('');
    return '<div class="qs" data-quick-sheet data-name="'+esc(p.title)+'" hidden><div class="qs-head"><span>Wybierz rozmiar</span>' +
      '<button type="button" class="qs-x" data-quick-close aria-label="Zamknij">×</button></div><div class="qs-sizes">'+btns+'</div></div>';
  }
  document.addEventListener('click', function(e){
    var bag=e.target.closest('[data-quick-add]');
    if(bag){
      var card=bag.closest('.rec'), sheet=card && card.querySelector('[data-quick-sheet]'); if(!sheet) return;
      e.preventDefault();
      var open=sheet.querySelectorAll('.qs-size:not([disabled])');
      if(sheet.querySelectorAll('.qs-size').length===1 && open.length===1){ open[0].click(); return; }   // one size: straight to the cart
      document.querySelectorAll('[data-quick-sheet]').forEach(function(q){ if(q!==sheet) q.hidden=true; });
      sheet.hidden=!sheet.hidden;
      return;
    }
    if(e.target.closest('[data-quick-close]')){ e.target.closest('[data-quick-sheet]').hidden=true; return; }
    var size=e.target.closest('.qs-size');
    if(size && !size.disabled){
      var sh=size.closest('[data-quick-sheet]');
      size.classList.add('is-busy');
      addToCart(+size.dataset.variant, 1, sh.dataset.name).then(function(){ sh.hidden=true; }).catch(function(){}).then(function(){ size.classList.remove('is-busy'); });
    }
  });
  function loadRecs(product, excludeIds, box, grid, limit){
    if(!box || !grid || !product || !product.product_id) return;
    var related=function(){ return fetch(ROOT+'recommendations/products.json?product_id='+product.product_id+'&limit=10&intent=related').then(function(r){ return r.json(); }); };
    var complements=fetch(ROOT+'products/'+product.handle+'?section_id=product-complements')
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        var m=/data-handles="([^"]*)"/.exec(html||''), hs=m ? m[1].split(',').filter(Boolean).slice(0, (limit||4)+2) : [];
        if(!hs.length) return related();
        return Promise.all(hs.map(function(h){ return fetch(ROOT+'products/'+h+'.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }); }))
          .then(function(list){ list=list.filter(Boolean); return list.length ? {products:list} : related(); });
      })
      .catch(related);
    complements
      .then(function(data){
        var seen={}, titles={};
        (excludeIds||[]).forEach(function(id){ seen[String(id)]=1; });
        var list=(data.products||[]).filter(function(p){
          // other colours of the same model share the title - show each model once
          if(seen[String(p.id)] || titles[p.title]) return false;
          titles[p.title]=1; return true;
        }).slice(0, limit||4);
        if(!list.length){ box.hidden=true; return; }
        grid.innerHTML=list.map(recCard).join('');
        window.HaColoCardGallery(grid);
        box.hidden=false;
        if(typeof syncWishButtons==='function') syncWishButtons();
      })
      .catch(function(){ box.hidden=true; });
  }

  function renderCartDrawer(cart, added){
    if(!drawer) return;
    updateCartCount(cart.item_count);
    var recBox=document.getElementById('CartDrawerRecs'), recGrid=document.getElementById('CartDrawerRecsGrid');
    if(added && added.length){
      drawerTitle.textContent = added.length>1 ? 'Produkty zostały dodane do koszyka' : 'Produkt został dodany do koszyka';
      drawerItems.innerHTML = added.map(function(i){ return lineHtml(i, false); }).join('');
      drawerTotalRow.hidden = true;
      drawerFooter.hidden = false;
    } else {
      drawerTitle.innerHTML = 'Koszyk (<span id="CartDrawerCount">'+cart.item_count+'</span>)';
      if(cart.item_count === 0){
        drawerItems.innerHTML = '<p class="empty-state">Twój koszyk jest pusty.</p>';
        drawer._sig = drawer._recSig = null;
        drawerFooter.hidden = true;
        renderShipping(cart); if(recBox) recBox.hidden=true;
        return;
      }
      // reopening an unchanged cart: keep what is on screen (no rebuild = no flicker, recommendations stay)
      var sig = cart.items.map(function(i){ return i.key+':'+i.quantity+':'+i.final_line_price; }).join('|')+'#'+cart.total_price;
      if(sig !== drawer._sig){
        drawerItems.innerHTML = cart.items.map(function(i){ return lineHtml(i, true); }).join('');
        drawer._sig = sig;
      }
      drawerTotal.textContent = money(cart.total_price);
      drawerTotalRow.hidden = false;
      drawerFooter.hidden = false;
    }
    if(added && added.length) drawer._sig = null;   // the "added" view replaced the list - rebuild it next time
    renderShipping(cart);
    var base=(added && added.length ? added[0] : cart.items[0]);
    var ids=cart.items.map(function(i){ return i.product_id; });
    // recommendations: only when the products in the cart (or the one just added) changed
    var recSig=(base ? base.product_id : '')+'/'+ids.slice().sort().join(',');
    if(recSig !== drawer._recSig || !recGrid || !recGrid.children.length){
      drawer._recSig = recSig;
      loadRecs(base, ids, recBox, recGrid, 6);
    }
  }

  function fetchCart(){
    return fetch(ROOT+'cart.js').then(function(r){ return r.json(); });
  }
  function showDrawer(){
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    if(drawerOverlay) drawerOverlay.classList.add('open');
  }
  function openDrawer(){
    if(!drawer) return;
    fetchCart().then(function(c){ renderCartDrawer(c); });
    showDrawer();
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    if(drawerOverlay) drawerOverlay.classList.remove('open');
  }
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function(a){
    a.addEventListener('click', function(e){
      if(!drawer || document.querySelector('[data-cart-page]')) return;   // on the cart page just go there
      e.preventDefault();
      openDrawer();
    });
  });
  var drawerClose=document.getElementById('CartDrawerClose');
  if(drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if(drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
  document.addEventListener('click', function(e){ if(e.target.closest('[data-cart-drawer-close]')) closeDrawer(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

  /* ---------- quantity +/- and remove (drawer and cart page) ---------- */
  function refreshCartPage(){
    var page=document.querySelector('[data-cart-page]');
    if(!page) return Promise.resolve();
    return fetch(ROOT+'cart?section_id='+encodeURIComponent(page.dataset.sectionId))
      .then(function(r){ return r.text(); })
      .then(function(html){
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var fresh=tmp.querySelector('[data-cart-page]');
        if(fresh){ page.innerHTML=fresh.innerHTML; loadRecRows(page); if(window.HaColoCardGallery) window.HaColoCardGallery(page); syncWishButtons(); shipSync(); }
      });
  }
  // inline note under a quantity field ("Dostępne tylko 11 szt."), stays until the line is re-rendered
  function qtyNote(key, text){
    document.querySelectorAll('[data-cart-qty="'+key+'"]').forEach(function(i){
      var wrap=i.closest('.qty-wrap') || i.closest('.qty-step').parentNode, n=wrap.querySelector('.qty-note');
      if(!n){ n=document.createElement('p'); n.className='qty-note'; i.closest('.qty-step').insertAdjacentElement('afterend', n); }
      n.textContent=text;
    });
  }
  function changeQty(key, qty, el){
    qty=Math.max(0, Math.min(999, parseInt(qty,10) || 0));
    // known stock limit (cart page): ask only for what there is
    var field=document.querySelector('[data-cart-qty="'+key+'"][data-max]'), max=field ? +field.dataset.max : 999;
    if(qty>max){ qty=max; say('Dostępne tylko '+max+' szt.'); }
    if(el) el.disabled=true;
    return fetch(ROOT+'cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      if(el) el.disabled=false;
      if(cart && cart.status){
        // more than in stock: Shopify refuses - put the real quantity back and say how many there are
        var n=/(\d+)/.exec(cart.description||'');
        var msg=n ? 'Dostępne tylko '+n[1]+' szt.' : (cart.description || 'Nie udało się zmienić ilości');
        say(msg);
        return fetchCart().then(function(c){
          if(drawer && drawer.classList.contains('open')) renderCartDrawer(c);
          return refreshCartPage().then(function(){ qtyNote(key, msg); });
        });
      }
      // less stock than asked: Shopify adds what it can - tell the customer
      var line=(cart.items||[]).filter(function(i){ return i.key===key; })[0];
      if(line && line.quantity<qty){ say('Dostępne tylko '+line.quantity+' szt.'); }
      if(drawer && drawer.classList.contains('open')) renderCartDrawer(cart);
      updateCartCount(cart.item_count);
      return refreshCartPage().then(function(){ if(line && line.quantity<qty) qtyNote(key, 'Dostępne tylko '+line.quantity+' szt.'); });
    })
    .catch(function(){ say('Błąd sieci, spróbuj ponownie'); if(el) el.disabled=false; });
  }
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-cart-change]');
    if(!b) return;
    e.preventDefault();
    changeQty(b.dataset.cartChange, b.dataset.qty, b);
  });
  // typed quantity (e.g. 20): saved on Enter or when the field loses focus
  document.addEventListener('focusin', function(e){
    var i=e.target.closest && e.target.closest('[data-cart-qty]');
    if(i){ i.dataset.was=i.value; setTimeout(function(){ i.select(); }, 0); }
  });
  document.addEventListener('keydown', function(e){
    var i=e.target.closest && e.target.closest('[data-cart-qty]');
    if(i && e.key==='Enter'){ e.preventDefault(); i.blur(); }
  });
  document.addEventListener('change', function(e){
    var i=e.target.closest && e.target.closest('[data-cart-qty]');
    if(!i) return;
    if(i.value===''){ i.value=i.dataset.was||1; return; }
    if(i.value!==i.dataset.was) changeQty(i.dataset.cartQty, i.value, i);
  });

  /* ---------- add to cart (AJAX, reusable) ---------- */
  function addToCart(variantId, quantity, name){
    quantity = quantity || 1;
    // Shopify.routes only has `root` (e.g. "/" or "/en/"), there is no cart_add_url
    return fetch(ROOT + 'cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: variantId, quantity: quantity }] })
    })
    .then(function(r){ return r.json().catch(function(){ return { status: r.status, description: 'Nie udało się dodać produktu' }; }); })
    .then(function(data){
      if(data && data.status){
        var n=data.status===422 && /(\d+)/.exec(data.description||'');
        say(n ? 'Brak tylu sztuk – dostępne: '+n[1]+' szt. (razem z tymi w koszyku)' : (data.description || 'Nie udało się dodać produktu'));
        return Promise.reject(data);
      }
      var added=data.items || [data];
      return fetchCart().then(function(cart){
        if(document.querySelector('[data-cart-page]')){ refreshCartPage(); updateCartCount(cart.item_count); say((name||'Produkt')+' — dodano do koszyka'); return cart; }
        renderCartDrawer(cart, added);
        showDrawer();
        return cart;
      });
    })
    .catch(function(err){
      if(!(err && err.status)) say('Błąd sieci, spróbuj ponownie');
      throw err;
    });
  }
  window.HaColoCart = { add: addToCart, open: openDrawer, close: closeDrawer };

  document.addEventListener('click', function(e){
    var b=e.target.closest('.add[data-add-to-cart]');
    if(!b) return;
    var card=b.closest('.card');
    var variantId=b.dataset.variantId;
    if(card && !variantId){
      var picked=card.querySelector('.szs button[aria-pressed="true"]');
      if(picked) variantId=picked.dataset.variantId;
    }
    if(!variantId){ if(card) askForSize(card); else say('Wybierz rozmiar'); return; }
    b.disabled=true;
    addToCart(variantId, 1, b.dataset.name)
      .then(function(){ b.disabled=false; })
      .catch(function(){ b.disabled=false; });
  });

  /* ---------- guard against Safari scrolling to top when selecting text
       inside an input that lives in a position:fixed header ---------- */
  (function(){
    var savedScrollY = null;
    document.querySelectorAll('[data-predictive-search-input]').forEach(function(input){
      input.addEventListener('mousedown', function(){ savedScrollY = window.scrollY; });
    });
    document.addEventListener('selectionchange', function(){
      if(savedScrollY === null) return;
      if(window.scrollY === 0 && savedScrollY > 20){
        window.scrollTo(0, savedScrollY);
      }
    });
    document.addEventListener('mouseup', function(){ savedScrollY = null; });
  })();

  /* ---------- predictive search ---------- */
  document.querySelectorAll('[data-predictive-search-input]').forEach(function(input){
    var wrap=input.closest('.predictive-search');
    var results=wrap ? wrap.querySelector('[data-predictive-search-results]') : null;
    if(!results) return;
    var t;
    input.addEventListener('input', function(){
      clearTimeout(t);
      var q=input.value.trim();
      if(q.length<2){ if(results.innerHTML!=='') results.innerHTML=''; return; }
      t=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
          .then(function(r){ return r.json(); })
          .then(function(data){
            var products=(data.resources && data.resources.results && data.resources.results.products) || [];
            if(!products.length){ results.innerHTML='<div class="psr-item"><span>Brak wyników</span></div>'; return; }
            var all=(ROOT||'/')+'search?type=product&options%5Bprefix%5D=last&q='+encodeURIComponent(q);
            results.innerHTML = products.map(function(p){
              var img = p.featured_image ? p.featured_image.url : '';
              var price = (+p.price).toFixed(2).replace('.', ',')+' zł';
              return '<a class="psr-item" href="'+p.url+'">'+
                (img?'<img src="'+img+'" alt="" loading="lazy">':'')+
                '<span><b>'+esc(p.title)+'</b><span>'+price+'</span></span></a>';
            }).join('') + '<a class="psr-all" href="'+all+'">Pokaż wszystkie wyniki</a>';
          })
          .catch(function(){});
      }, 250);
    });
    document.addEventListener('click', function(e){
      if(!wrap.contains(e.target)) results.innerHTML='';
    });
    input.addEventListener('keydown', function(e){ if(e.key==='Escape'){ results.innerHTML=''; input.blur(); } });
    // Enter submits the form (search page); drop the dropdown so it doesn't hang over the page while it loads
    var form=input.form; if(form) form.addEventListener('submit', function(e){
      if(!input.value.trim()){ e.preventDefault(); return; }
      clearTimeout(t); results.innerHTML='';
    });
  });

})();
